// Frontend env values are public. Never put server secrets here.
const hostname = typeof window === "undefined" ? "" : window.location.hostname.toLowerCase();
const productionHosts = (process.env.REACT_APP_PRODUCTION_HOSTS || "").split(",").map(host => host.trim().toLowerCase()).filter(Boolean);
export const API_ENVIRONMENT = productionHosts.includes(hostname) ? "production" : "uat";
const isProduction = API_ENVIRONMENT === "production";
const baseUrl = value => {
  if (!value) throw new Error("Missing API base URL in environment configuration");
  return value.replace(/\/+$/, "") + "/";
};
const endpoint = (base, path) => {
  if (!path) throw new Error("Missing API endpoint path in environment configuration");
  return base + path.replace(/^\/+/, "");
};

// WEBSITE
export const API_URL = baseUrl(isProduction ? process.env.REACT_APP_PRODUCTION_WEBSITE_URL : process.env.REACT_APP_UAT_WEBSITE_URL);
export const ALUMNI_API_URL = endpoint(API_URL, process.env.REACT_APP_ALUMNI_PATH);
export const LOAN_API_URL = endpoint(API_URL, process.env.REACT_APP_LOAN_PATH);
export const VISITOR_COUNT_API_URL = endpoint(API_URL, process.env.REACT_APP_VISITOR_COUNT_PATH);
export const GRIEVANCE_API_URL = endpoint(API_URL, process.env.REACT_APP_GRIEVANCE_PATH);
export const GRIEVANCE_USER_API_URL = endpoint(API_URL, process.env.REACT_APP_GRIEVANCE_USER_PATH);
export const GRIEVANCE_MOBILE_API_URL = endpoint(API_URL, process.env.REACT_APP_GRIEVANCE_MOBILE_PATH);
export const GRIEVANCE_OTP_API_BASE = endpoint(API_URL, process.env.REACT_APP_GRIEVANCE_OTP_PATH);
export const CATEGORY_SUBCATEGORY_API_URL = endpoint(API_URL, process.env.REACT_APP_CATEGORY_SUBCATEGORY_PATH);
export const FILE_UPLOAD_API_URL = endpoint(API_URL, process.env.REACT_APP_FILE_UPLOAD_PATH);
export const FILE_API_URL = endpoint(API_URL, process.env.REACT_APP_FILE_PATH);
export const LOGIN_URL = endpoint(API_URL, process.env.REACT_APP_LOGIN_PATH);
export const KPI_URL = endpoint(API_URL, process.env.REACT_APP_KPI_PATH);
export const USER_ENGAGEMENT_URL = endpoint(API_URL, process.env.REACT_APP_USER_ENGAGEMENT_PATH);

// CHATBOT: all deployments use the production chatbot service.
export const CHATBOT_API_URL = baseUrl(process.env.REACT_APP_PRODUCTION_CHATBOT_URL);
export const CHATBOT_URL = endpoint(CHATBOT_API_URL, process.env.REACT_APP_CHATBOT_PATH);
export const CALL_AGENT_STREAM_URL = endpoint(CHATBOT_API_URL, process.env.REACT_APP_CHATBOT_STREAM_PATH);
export const SPEECH_TO_TEXT_URL = endpoint(CHATBOT_API_URL, process.env.REACT_APP_SPEECH_TO_TEXT_PATH);
export const TTS_URL = endpoint(CHATBOT_API_URL, process.env.REACT_APP_TTS_PATH);
export const TRANSLITERATE_URL = endpoint(CHATBOT_API_URL, process.env.REACT_APP_TRANSLITERATE_PATH);

// External services
export const BHASHINI_ENDPOINT_URL = process.env.REACT_APP_BHASHINI_ENDPOINT_URL;
export const BHASHINI_SOCKET_URL = process.env.REACT_APP_BHASHINI_SOCKET_URL;
export const BHASHINI_SCRIPT_URL = process.env.REACT_APP_BHASHINI_SCRIPT_URL;
export const GEOCODING_URL = process.env.REACT_APP_GEOCODING_URL;
export const YOUTUBE_OEMBED_URL = process.env.REACT_APP_YOUTUBE_OEMBED_URL;
export const MICROLINK_URL = process.env.REACT_APP_MICROLINK_URL;
export const DISTRICT_MAP_URL = process.env.REACT_APP_DISTRICT_MAP_URL;
export const VAD_MODEL_URL = process.env.REACT_APP_VAD_MODEL_URL;
export const VAD_WORKLET_URL = process.env.REACT_APP_VAD_WORKLET_URL;
export const BHASHINI_API_KEY = process.env.REACT_APP_BHASHINI_API_KEY;
export const BHASHINI_SOCKET_API_KEY = process.env.REACT_APP_BHASHINI_SOCKET_API_KEY;
